import apiService from './apiService';

//  UPDATED: merged search into main function — accepts page and search
export const getSpecificInstruction = async (page: number = 1, search = '') => {
  try {
    const params = new URLSearchParams({
      page: String(page),
    });

    if (search) params.append('filter[search]', search);

    const response = await apiService.get(`/specific-instructions?${params.toString()}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching specific-instructions:', error);
    throw error;
  }
};

export const getSpecificInstructionDetail = async (id: number | string) => {
  try {
    const response = await apiService.get(`/specific-instructions/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching specific-instruction detail:', error);
    throw error;
  }
};

export const createSpecificInstruction = async (payload: any) => {
  try {
    const response = await apiService.post('/specific-instructions', payload);
    return response.data;
  } catch (error) {
    console.error('Error creating specific-instruction:', error);
    throw error;
  }
};

export const updateSpecificInstruction = async (id: number | string, payload: any) => {
  try {
    const response = await apiService.put(`/specific-instructions/${id}`, payload);
    return response.data;
  } catch (error) {
    console.error('Error updating specific-instruction:', error);
    throw error;
  }
};

export const deleteSpecificInstruction = async (id: number | string) => {
  try {
    const response = await apiService.delete(`/specific-instructions/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting specific-instruction:', error);
    throw error;
  }
};

// ✅ UPDATED: Changed type to match backend requirement (user_ids as array)
export const notifyAccept = async (id: number | string, payload: { user_ids: number[] }) => {
  try {
    const response = await apiService.post(`/specific-instructions/${id}/notify-accept`, payload);
    return response.data;
  } catch (error) {
    console.error('Error notifying accept:', error);
    throw error;
  }
};

export const markAccepted = async (id: number | string) => {
  try {
    const response = await apiService.post(`/specific-instructions/${id}/mark-accepted`, {});
    return response.data;
  } catch (error) {
    console.error('Error marking accepted:', error);
    throw error;
  }
};

export const getTechnicalSupportOfficers = async () => {
  try {
    const response = await apiService.get('/users?filter[user_type_id]=11');
    return response.data;
  } catch (error) {
    console.error('Error fetching TSOs:', error);
    throw error;
  }
};

export const getOperationManagers = async () => {
  try {
    const response = await apiService.get('/users?filter[user_type_id]=9');

    return response.data;
  } catch (error) {
    console.error('Error fetching operation managers:', error);
    throw error;
  }
};

export const notifyAuthorize = async (id: string | number, payload: { user_ids: number[] }) => {
  try {
    const response = await apiService.post(`/specific-instructions/${id}/notify-authorize`, payload);
    return response.data;
  } catch (error) {
    console.error('Error notifying authorize:', error);
    throw error;
  }
};

export const markAuthorized = async (id: number | string) => {
  try {
    const response = await apiService.post(`/specific-instructions/${id}/mark-authorized`, {});
    return response.data;
  } catch (error) {
    console.error('Error marking authorized:', error);
    throw error;
  }
};

export const notifyCarryOutInstruction = async (id: string | number, payload: { user_ids: number[] }) => {
  try {
    const response = await apiService.post(`/specific-instructions/${id}/notify-carry-out`, payload);
    return response.data;
  } catch (error) {
    console.error('Error notifying carry out instruction:', error);
    throw error;
  }
};

export const getShiftSupervisors = async () => {
  try {
    const response = await apiService.get('/users?filter[user_type_id]=2');

    return response.data;
  } catch (error) {
    console.error('Error fetching shift supervisors:', error);
    throw error;
  }
};

export const markCarriedOutInstruction = async (id: number | string) => {
  try {
    const response = await apiService.post(`/specific-instructions/${id}/mark-carried-out`, {});
    return response.data;
  } catch (error) {
    console.error('Error marking carried out instruction', error);
    throw error;
  }
};

export const notifySubmitReport = async (id: string | number, payload: { user_ids: number[] }) => {
  try {
    const response = await apiService.post(`/specific-instructions/${id}/notify-submit`, payload);

    return response.data;
  } catch (error) {
    console.error('Error notifying submit report:', error);
    throw error;
  }
};

export const getSystemEngineer = async () => {
  try {
    const response = await apiService.get('/users?filter[user_type_id]=6');

    return response.data;
  } catch (error) {
    console.error('Error fetching system engineer:', error);
    throw error;
  }
};

export const markSubmitted = async (id: number | string) => {
  try {
    const response = await apiService.post(`/specific-instructions/${id}/mark-submitted`, {});

    return response.data;
  } catch (error) {
    console.error('Error marking submitted:', error);
    throw error;
  }
};

export const downloadSpecificInstructionPdf = async (id: number | string) => {
  try {
    const response = await apiService.get(`/specific-instructions/${id}/download`, {
      responseType: 'blob',
    });

    return response.data;
  } catch (error) {
    console.error('Error downloading PDF:', error);
    throw error;
  }
};
